const isReactDevServer =
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") &&
    window.location.port === "3000";

const API_BASE = process.env.REACT_APP_API_BASE_URL || (isReactDevServer ? "http://localhost:8090/backend" : "/backend");

export const API = {
    admin: `${API_BASE}/admin.php`,
    contentAudit: `${API_BASE}/cleanFillerPhrases.php`,
    getNews: `${API_BASE}/getNews.php`,
    getWoman: `${API_BASE}/getWoman.php`,
    minigame: `${API_BASE}/minigame.php`,
    migrateMonthlyWoman: `${API_BASE}/migrateMonthlyWoman.php`,
    migrateTranslations: `${API_BASE}/migrateTranslations.php`,
    result: `${API_BASE}/result.php`,
    support: `${API_BASE}/support.php`,
};

export default API;
